<label [ngClass]="statusClass" [style.backgroundColor]="bgColor">{{ status }} </label>